import letterIcon from "../assets/img/letter_icon.png";

function NewsLetter() {
  return (
    <div className="side_wrap">
      <a
        href="https://page.stibee.com/subscriptions/146545"
        target="_blank"
        rel="noopener noreferrer"
        className="newsletter"
      >
        <img src={letterIcon} alt="letter icon" />
        뉴스레터
      </a>
    </div>
  );
}

export default NewsLetter;
